/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2023-01-14 22:21:01
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-02-25 00:23:08
 * @FilePath: /wemeet-web-activity/src/pages/questions/components/input/index.tsx
 * @Description: 输入框需要自动填入姓名
 */
import React, { memo, useEffect, useState } from 'react';
// import { UserData } from '@utils/login-util';
import { QuestionType } from "../../type/index";
import { Input } from '@tencent/tea-component';
const FormInput = ({
  userData,
  item,
  onChange,
  onBlur,
  list
}) => {
  const [hasChange, setHasChange] = useState(false);
  useEffect(() => {
    if (!hasChange && item.question_type === QuestionType.NAME && !item.answer && userData?.nick_name) {
      onChange(userData.nick_name);
    }
  }, [userData, list, hasChange]);
  useEffect(() => {
    if (item.answer) {
      onBlur();
    }
  }, []);
  return /*#__PURE__*/React.createElement(Input, {
    value: item.answer,
    placeholder: "\u8BF7\u8F93\u5165",
    size: "full",
    onChange: val => {
      setHasChange(true);
      onChange(val);
    },
    onBlur: onBlur,
    maxLength: 50
  });
};
export default /*#__PURE__*/memo(FormInput);